(() => {
  const gczText = (text) => window.GAUCZ_I18N?.[text] ?? text;
  document.querySelectorAll('form.gcz-form').forEach((form) => {
    if (form.dataset.gauczReady === 'true') return;
    form.dataset.gauczReady = 'true';
    const submit = form.querySelector('button[type="submit"]');
    const originalText = submit?.textContent;

    form.querySelectorAll('[required]').forEach((field) => {
      field.addEventListener('invalid', () => {
        const message = field.validity.typeMismatch
          ? gczText('Zadejte prosím platnou e-mailovou adresu.')
          : gczText('Vyplňte prosím toto pole.');
        field.setCustomValidity(message);
      });
      field.addEventListener('input', () => field.setCustomValidity(''));
      field.addEventListener('change', () => field.setCustomValidity(''));
    });

    form.addEventListener('submit', () => {
      if (!form.checkValidity() || !submit) return;
      submit.disabled = true;
      submit.textContent = gczText('Odesílám…');
      window.setTimeout(() => {
        submit.disabled = false;
        submit.textContent = originalText;
      }, 8000);
    });
  });
})();
